import validate from 'validate.js';

function validateFirstname(data) {
  let error = '';
  let errorState = false;
  if (validate.single(data, { presence: { allowEmpty: false } })) {
    error = 'This field is required';
    errorState = true;
  }
  if (data[0] === ' ' || data[data.length - 1] === ' ') {
    error = 'Leading or trailing whitespace not allowed';
    errorState = true;
  }
  return [error, errorState];
}

function validateLastname(data) {
  let error = '';
  let errorState = false;
  if (validate.single(data, { presence: { allowEmpty: false } })) {
    error = 'This field is required';
    errorState = true;
  }
  if (data[0] === ' ' || data[data.length - 1] === ' ') {
    error = 'Leading or trailing whitespace not allowed';
    errorState = true;
  }
  return [error, errorState];
}

function validateEmail(data) {
  let error = '';
  let errorState = false;
  if (validate.single(data, { email: true })) {
    error = 'Must be a valid email address';
    errorState = true;
  }
  if (validate.single(data, { presence: { allowEmpty: false } })) {
    error = 'This field is required';
    errorState = true;
  }
  if (data[0] === ' ' || data[data.length - 1] === ' ') {
    error = 'Leading or trailing whitespace not allowed';
    errorState = true;
  }
  return [error, errorState];
}

function validateUsername(data) {
  let error = '';
  let errorState = false;
  if (validate.single(data, { presence: { allowEmpty: false } })) {
    error = 'This field is required';
    errorState = true;
  }
  if (data.includes(' ')) {
    error = 'Whitespace not allowed';
    errorState = true;
  }
  return [error, errorState];
}

function validatePassword(data) {
  let error = '';
  let errorState = false;
  if (validate.single(data, { length: { minimum: 8 } })) {
    error = 'Password must be at least 8 characters';
    errorState = true;
  }
  if (validate.single(data, { presence: { allowEmpty: false } })) {
    error = 'This field is required';
    errorState = true;
  }
  if (data.includes(' ')) {
    error = 'Whitespace not allowed';
    errorState = true;
  }
  return [error, errorState];
}

export {
  validateFirstname,
  validateLastname,
  validateEmail,
  validateUsername,
  validatePassword,
};

